"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorsemansInfernoAbilityHandler = exports.HorsemansInfernoActorAbilityFactory = exports.HorsemansInfernoAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class HorsemansInfernoAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HorsemansInferno;
        this.__typeName = "HorsemansInferno";
    }
}
exports.HorsemansInfernoAbilityArgs = HorsemansInfernoAbilityArgs;
let HorsemansInfernoActorAbilityFactory = class HorsemansInfernoActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HorsemansInferno", "AllEnemies", 1);
    }
};
HorsemansInfernoActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HorsemansInferno")
], HorsemansInfernoActorAbilityFactory);
exports.HorsemansInfernoActorAbilityFactory = HorsemansInfernoActorAbilityFactory;
let HorsemansInfernoAbilityHandler = class HorsemansInfernoAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 40),
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 40)
                ],
                effects: [
                    {
                        duration: Duration_1.Duration.Permanent,
                        effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 1),
                        targetId
                    },
                    {
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.BurningEffectArgs("Focus", 10),
                        targetId
                    }
                ],
            })),
            onHit: (sequence, { targetId }) => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "BluePurpleExplosion"));
            }
        });
    }
};
HorsemansInfernoAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HorsemansInferno)
], HorsemansInfernoAbilityHandler);
exports.HorsemansInfernoAbilityHandler = HorsemansInfernoAbilityHandler;
